<ion-menu
  side="end"
  contentId="main"
  menuId="one-to-one-chat"
  type="overlay"
  [ngStyle]="{ '--min-width': '400px' }"
  (ionDidClose)="onMenuClose()"
>
  <ion-header>
    <ion-toolbar>
      <ion-button
        slot="start"
        fill="clear"
        (click)="closeSidebar()"
      >
<!--        <ion-icon-->
<!--          class="color-shape-border"-->
<!--          slot="icon-only"-->
<!--          name="close"-->
<!--          size="small"-->
<!--        ></ion-icon>-->
        <tr-icon
          slot="icon-only"
          [icon]="icon.cancel"
          [size]="iconSize.belowAverage"
          [color]="iconColor.lightPrimary"
        ></tr-icon>
      </ion-button>

      @if (party && isCompactLayout) {
        <div class="chat-title-row">
          <span class="chat-title-text">Chat with <span data-dd-privacy="mask">{{ party.name }}</span></span>
          <tablesready-party-badge [party]="party" [showTypeBadge]="true"></tablesready-party-badge>
        </div>
      }
    </ion-toolbar>
  </ion-header>

  <ion-content [scrollY]="false">
    <section>
      @if (party) {
        <lib-frontend-chat-party
          [editPartyMethod]="editPartyMethod"
          [showPartyInfo]="showPartyInfo"
          [location]="location"
          [timezone]="location?.timezone"
          [party]="party"
          [showReplyForm]="!readOnly"
          [showTemplates]="!readOnly && (features?.savedReplies || false)"
          [canSendChat]="canSendChat"
          [onUpgradeNeeded]="onUpgradeNeeded"
          [hideTitle]="isCompactLayout"
          [cancel]="closeSidebar"
        ></lib-frontend-chat-party>
      }
    </section>
  </ion-content>
</ion-menu>
